/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Text } from "../../atoms";
import * as styles from "./index.styles";
import { login } from "../../../redux/actions/auth/login";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../../components/templates";
import { useTranslation } from "react-i18next";

const Notifications: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const handleLogout = () => {
    dispatch(login("LOGOUT"));
    navigate("/login");
    setShow(false);
  };

  return (
    <div css={styles.root}>
      <Modal
        show={show}
        title={t("auth:text_logout")}
        text=""
        btnSuccess={t("common:text_yes")}
        btnWarning={t("common:text_no")}
        onClickSuccess={handleLogout}
        onClickWarning={() => setShow(false)}
        onClickClose={() => setShow(false)}
      />

      <button
        type="button"
        css={styles.logoutButton}
        onClick={() => setShow(true)}
      >
        <Text textType="sm" weight="bold">
          Cerrar sesión
        </Text>
      </button>
    </div>
  );
};

export default Notifications;